
// Copyright 2002-2013, University of Colorado Boulder

/**
 * This model implementation tracks the location of the pointer(s), if any, so they can be visualized during playback.
 *
 * @author Sam Reid (PhET Interactive Simulations)
 */
define( 'JOIST/share/Pointers',['require','JOIST/share/Pointer'],function( require ) {
  'use strict';

  var Pointer = require( 'JOIST/share/Pointer' );

  //TODO: make it an observable array 
  return [];
} );